import { ElDropdown } from 'element-plus/es';
import 'element-plus/es/components/dropdown/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c60914e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-view"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "h_left"
};
const _hoisted_4 = {
  class: "h_left_t"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-jichuguanli-copy"
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返回首页 ", -1));
const _hoisted_7 = [_hoisted_5, _hoisted_6];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-gupiao"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "股票资讯", -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h_centre"
}, [/*#__PURE__*/_createElementVNode("p", null, "股票资讯")], -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-jia"
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返回首页", -1));
const _hoisted_14 = [_hoisted_12, _hoisted_13];
const _hoisted_15 = {
  class: "main"
};
import { reactive, ref } from "@vue/reactivity";
import { onMounted, onUpdated } from "@vue/runtime-core";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
// const hactive: computed(() => store.state.hactive);
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {
    const stata = reactive({
      issearch3: ref(false)
    });
    const $router = useRouter();
    const $route = useRoute();
    // const store = useStore();
    const {
      state,
      commit,
      dispatch
    } = useStore();
    onMounted(() => {
      pathactive3();
      methods.getSearch();
    });
    onUpdated(() => {
      pathactive3();
    });
    // 头部 菜单的点击事件
    const bindheader = pathname => {
      if ($route.path == `/${pathname}`) return;
      $router.push(`/${pathname}`);
      commit("UpActive", pathname);
    };
    // 保持头部的 当前的激活
    const pathactive3 = () => {
      let pathactive3 = $route.path.split("/")[1];
      console.log(pathactive3);
      commit("UpActive", pathactive3);
    };
    let methods = {
      getSearch() {
        var url = decodeURI(window.location.search);
        if (url.indexOf("?") != -1) {
          var str = url.substr(1); //得到?后面的字符串
          // var strs = str.split("&");
          let a = RegExp(/search=1/);
          stata.issearch3 = a.test(str);
        }
      },
      goRealTime() {
        $router.push("/");
        stata.issearch3 = false;
      },
      // 选项下拉的点击事件
      ElDropdown(e) {
        let $index = e.target.dataset.index;
        if ($index == 2) {
          // 退出首页
          $router.push('/');
        }
      }
    };
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("ul", _hoisted_4, [_createElementVNode("li", {
        onClick: _cache[0] || (_cache[0] = $event => bindheader(''))
      }, _hoisted_7), _createElementVNode("li", {
        class: _normalizeClass([{
          active: _unref(state).hactive == 'gupiao'
        }]),
        onClick: _cache[1] || (_cache[1] = $event => bindheader('gupiao'))
      }, _hoisted_10, 2)])]), _hoisted_11, _unref(stata).issearch3 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "homepage",
        onClick: _cache[2] || (_cache[2] =
        //@ts-ignore
        (...args) => _unref(methods).goRealTime && _unref(methods).goRealTime(...args))
      }, _hoisted_14)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_router_view)])]);
    };
  }
});